// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import { connect } from "react-redux";

import {
  Common as StyledCommon,
  NotificationContainer,
  Comment,
  CommonContent,
} from "./styles";
import NameOrEmail from "src/containers/user/NameOrEmail";
import ChatTimestamp from "src/components/messages/Chat/ChatTimestamp";

import type { UID, RoomId } from "src/types";

type Props = {
  currentUser: UID,
  author: UID,
  dataCy?: ?string,
  timestamp: string,
  children: any,
  read: boolean,
  delivered: boolean,
  comment: string,
  currentRoomAddress: RoomId,
  blackText: boolean,
};

const Common = ({
  currentUser,
  author,
  timestamp,
  children,
  read,
  dataCy = null,
  delivered,
  comment,
}: Props) => (
  <NotificationContainer data-cy="notification-container">
    <StyledCommon data-cy={dataCy} isItYou={currentUser === author}>
      <CommonContent>
        {comment && <Comment data-cy="notification-comment">{comment}</Comment>}
        <strong>
          {currentUser === author ? (
            i18n.t(k.YOU)
          ) : (
            <NameOrEmail
              uid={author}
              showPending={false}
              notificationVariant="common"
            />
          )}
        </strong>
        {children}
      </CommonContent>
      <ChatTimestamp read={read} delivered={delivered} timestamp={timestamp} />
    </StyledCommon>
  </NotificationContainer>
);

const mapStateToProps = ({ app }) => ({
  currentUser: app.currentUser.uid,
});

export default connect(mapStateToProps)(Common);
